var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"largeImgWrap"},[_c('img',{staticClass:"img",attrs:{"src":_vm.img,"alt":""}}),(_vm.labelText)?_c('div',[_c('span',{staticClass:"lightText"},[_vm._v("标签")]),_c('span',[_vm._v(_vm._s(_vm.labelText))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }